import { HttpClient } from '@adapters/HttpClient';
import { AxiosRequestConfig } from 'axios';
import type {
  LogisticPivotData,
  LogisticPivotExportResponse,
  LogisticPivotQuery,
  LogisticPivotSuccessBody,
} from '../models/LogisticPivot';

function serializeLogisticPivotParams(params: Record<string, unknown>): string {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) continue;
    if (key === 'dimensions' && Array.isArray(value)) {
      for (const v of value) {
        parts.push(`dimensions[]=${encodeURIComponent(String(v))}`);
      }
      continue;
    }
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  }
  return parts.join('&');
}

function buildParams(query?: LogisticPivotQuery): Record<string, unknown> {
  if (!query) return {};
  const params: Record<string, unknown> = {};

  if (query.start_date) params.start_date = query.start_date;
  if (query.end_date) params.end_date = query.end_date;
  if (query.date_column) params.date_column = query.date_column;
  if (query.dimensions && query.dimensions.length > 0) {
    params.dimensions = query.dimensions;
  }
  if (query.team_id != null) params.team_id = query.team_id;
  if (query.payment_method_id != null) params.payment_method_id = query.payment_method_id;
  if (query.shop_id != null) params.shop_id = query.shop_id;
  if (query.courier_id != null) params.courier_id = query.courier_id;
  if (query.country_id != null) params.country_id = query.country_id;
  if (query.courier_service_id != null) params.courier_service_id = query.courier_service_id;

  return params;
}

export class LogisticPivotApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getLogisticPivot(query?: LogisticPivotQuery): Promise<LogisticPivotData> {
    const params = buildParams(query);
    const config: AxiosRequestConfig = {
      paramsSerializer: serializeLogisticPivotParams,
    };

    const body = await this.httpClient.get<LogisticPivotSuccessBody>(
      '/report/logistic-pivot',
      params,
      config
    );

    if (!body?.success || !body.data) {
      throw new Error('Respuesta inválida del reporte logístico pivot');
    }

    return body.data;
  }

  /**
   * GET — mismos query params que {@link getLogisticPivot}.
   * Respuesta: `{ url_file }` con la URL del .xlsx generado.
   */
  async exportLogisticPivotExcel(query?: LogisticPivotQuery): Promise<LogisticPivotExportResponse> {
    const params = buildParams(query);
    const config: AxiosRequestConfig = {
      paramsSerializer: serializeLogisticPivotParams,
    };
    const data = await this.httpClient.get<LogisticPivotExportResponse>(
      '/report/logistic-pivot/export',
      params,
      config,
      false
    );
    if (!data?.url_file) {
      throw new Error('La respuesta de exportación no contiene url_file');
    }
    return data;
  }
}
